// extracted by mini-css-extract-plugin
export default {"options_parent":"SearchBar_options_parent__Ej79R","options_box":"SearchBar_options_box__5mTUJ"};